import { Reveal, Kicker } from "./Reveal";

const METRICS = [
  ["LIFT", "Does PriceStrike create economic value?", "Measured margin or revenue improvement versus an agreed holdout or comparator."],
  ["AUTONOMY", "Will customers delegate commercial authority?", "The share of eligible decisions executed without individual human approval."],
  ["ZERO", "Does the control layer work?", "Out-of-policy executions."],
];

const TARGETS = ["Three 90-day pilots", "30%+ decisions auto-within-bounds", "Zero out-of-policy executions"];

export default function ProofNumbers() {
  return (
    <section id="evidence" className="border-b border-white/10 bg-[#0A0A0B]" data-testid="evidence-section">
      <div className="mx-auto max-w-[1600px] px-6 py-28 lg:px-12 lg:py-40">
        <Reveal>
          <Kicker index="04" label="The evidence" />
          <h2 className="font-display text-4xl font-extrabold leading-[1.02] tracking-tighter sm:text-5xl lg:text-6xl" data-testid="evidence-heading">
            Lift. Autonomy. <span className="text-[#00FF41]">Zero.</span>
          </h2>
        </Reveal>

        <div className="mt-20 grid gap-px border border-white/10 bg-white/10 lg:grid-cols-3">
          {METRICS.map(([name, question, desc], i) => (
            <Reveal key={name} delay={i * 0.1} className="bg-[#0A0A0B] p-10 transition-colors duration-500 hover:bg-[#0F0F11]">
              <div className="font-display text-4xl font-extrabold tracking-tighter text-[#00FF41]" data-testid={`proof-${name.toLowerCase()}`}>{name}</div>
              <div className="mt-6 font-mono text-sm text-white">{question}</div>
              <p className="mt-4 font-mono text-xs leading-relaxed text-zinc-500">{desc}</p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <p className="mt-12 max-w-3xl font-mono text-sm leading-relaxed text-zinc-400" data-testid="evidence-explanation">
            Lift proves economics. Autonomy proves delegation. Zero proves control.{" "}
            <span className="text-white">All three together prove the Commercial Decision Infrastructure thesis.</span>
          </p>
          <div className="mt-8 flex flex-wrap gap-3" data-testid="evidence-targets">
            <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-500">Design-partner target:</span>
            {TARGETS.map((t) => (
              <span key={t} className="border border-[#00FF41]/40 px-4 py-2 font-mono text-[11px] uppercase tracking-[0.2em] text-[#00FF41]">
                {t}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
